<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import getInitials from '@/helpers/get-initials'
import api from '@/helpers/api'
import simplebar from 'simplebar-vue'

export default {
  name: 'sales.customers.settings',
  page: {
    title: 'Sales - Customer',
    meta: [{ name: 'description', settings_content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data: () => ({
    isLoading: false
  }),

  computed: {
    title () {
      return 'Settings'
    },
    breadcrumbs () {
      return [
        {
          text: 'Settings',
          to: { name: 'settings.general' }
        },
        {
          text: 'General',
          active: true
        }
      ]
    }
  }
}
</script>
<template>
  <Layout>
    <PageHeader :items="breadcrumbs">
      <template v-slot:title>
        <div class="d-flex flex-column">
          <div>
            <h4 class="mb-0">
              Settings
            </h4>
          </div>
        </div>
      </template>
    </PageHeader>

    <b-row>
      <b-col cols="12">
        <b-card no-body class="email-leftbar p-2">
          <b-nav vertical class="side-nav">
            <b-nav-item :to="{ name: 'settings.general' }" exact>
              <i class="bx bx-info-circle mr-1"></i>General
            </b-nav-item>
            <b-nav-item :to="{ name: 'settings.product-categories' }" exact>
              <i class="bx bx-purchase-tag-alt mr-1"></i>Product Categories
            </b-nav-item>
            <b-nav-item :to="{ name: 'settings.shops' }" exact>
              <i class="bx bx-store-alt mr-1"></i>Web Shops
            </b-nav-item>
            <b-nav-item :to="{ name: 'settings.attributes' }" exact>
              <i class="fas fa-tag mr-1"></i>Attributes
            </b-nav-item>
            <b-nav-item :to="{ name: 'settings.translations' }" exact>
              <i class="bx bx-globe mr-1"></i>Translations
            </b-nav-item>
          </b-nav>
        </b-card>

        <div class="email-rightbar">
          <router-view />
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
